import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const freshdesk = defineConnector({
  identifier: "freshdesk",
  name: "Freshdesk",
  tagLine: "Customer support software",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () => "https://.*\\.freshdesk\\.com/.*",
  auth: (app) =>
    basicAuth({
      username: app.secret.apiKey,
      password: "X",
    }),
  steps: [
    {
      title: "Get your Freshdesk API key",
      items: [
        {
          kind: "markdown",
          content:
            "Log in to your Freshdesk account. Click your profile picture in the top right corner and select **Profile Settings**.\n\nYour API key is displayed under the **Your API Key** section on the right side.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "hostname",
          label: "Domain",
          required: true,
          placeholder: "yourcompany.freshdesk.com",
          target: { kind: "configuration", field: "domain" },
          helperText: "Your Freshdesk domain (e.g., yourcompany.freshdesk.com)",
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ domain }) => `https://${domain}/api/v2/tickets?per_page=1`,
  },
  publicEnvVars: ({ domain }) => ({
    FRESHDESK_URL: domain ? `https://${domain}` : "",
  }),
});
